import type { ReactNode, Ref } from "react";
import type { TamaguiElement } from "tamagui";
import { SkeletonText, Subtitle1, XStack, YStack } from "@medbillai/ui";

// Shared section wrapper for "Your cases" and "Quick start" — one header treatment.
export type HomeSectionProps = {
  title: string;
  headerTrailing?: ReactNode;
  /** Skeleton title; header trailing is suppressed while loading. */
  loading?: boolean;
  /** Ref to the section's root, used to scroll the section into view. */
  containerRef?: Ref<TamaguiElement>;
  children: ReactNode;
};
export function HomeSection({
  title,
  headerTrailing,
  loading = false,
  containerRef,
  children
}: HomeSectionProps) {
  return <YStack gap="$sp2" ref={containerRef} aria-busy={loading || undefined} data-sentry-element="YStack" data-sentry-component="HomeSection" data-sentry-source-file="HomeSection.tsx">
      <XStack ai="center" jc="space-between" gap="$sp2" data-sentry-element="XStack" data-sentry-source-file="HomeSection.tsx">
        <SkeletonText loading={loading} chars={10} data-sentry-element="SkeletonText" data-sentry-source-file="HomeSection.tsx">
          <Subtitle1 color="$textSubtle" data-sentry-element="Subtitle1" data-sentry-source-file="HomeSection.tsx">{title}</Subtitle1>
        </SkeletonText>
        {loading ? null : headerTrailing}
      </XStack>
      {children}
    </YStack>;
}